import { useEffect } from 'react';
import { NSButtonBase } from 'bricks/NSButton/NSButton';
import { useLocalStorage, GlobalKeys, ConsentValue } from 'helpers/localStorage';
import { setDatadogTrackingConsent } from 'utils/initDatadogRum';
import './CookieConsentBanner.scss';

const CookieConsentBanner = () => {
    const [consent, setConsent] = useLocalStorage<ConsentValue | null>(GlobalKeys.CookieConsent, null);

    useEffect(() => {
        if (consent) {
            setDatadogTrackingConsent(consent);
        }
    }, [consent]);

    const handleAccept = () => setConsent(ConsentValue.Granted);
    const handleDecline = () => setConsent(ConsentValue.NotGranted);

    if (consent) return null;

    return (
        <div
            className="CookieConsentBanner fixed-bottom d-flex flex-column flex-md-row align-items-center gap-3 justify-content-center px-3 py-3"
            role="region"
            aria-label="Cookie consent notice"
        >
            <p className="mb-0 text-center">
                We use cookies and similar technologies to improve your experience,
                analyze site usage, and assist in our marketing efforts.
            </p>
            <div className="mt-2 mt-lg-0 d-flex text-nowrap">
                <NSButtonBase
                    outline
                    text="Reject all"
                    callback={handleDecline}
                    className="btn-secondary ml-2"
                />
                <NSButtonBase
                    color="primary"
                    text="Allow all"
                    callback={handleAccept}
                    className="ml-2"
                />
            </div>
        </div>
    );
};

export default CookieConsentBanner;
